import { useAppDispatch } from 'store/hooks';
import settingStaffSelectors from '../selectors';
import settingStaffActions from '../actions';
import { useEffect } from 'react';

const useGetListDateOverrideStaff = (staffId: string) => {
  const dispatch = useAppDispatch();
  const listDateOverride = settingStaffSelectors.getListDateOverride();

  const mutate = (staffId: string) => {
    dispatch(settingStaffActions.getListDateOverride.fetch(staffId));
  };

  useEffect(() => {
    mutate(staffId);
  }, [staffId]);

  return {
    listDateOverride,
    mutate,
  };
};
export default useGetListDateOverrideStaff;
